module.exports = __webpack_public_path__ + "02_face.edb938b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/02_face.png
// module id = Tuke
// module chunks = 0